import { useEffect, useState } from "react";
import { getNativeNetworkStatus, isElectron } from "../renderer/platform";
import { subscribeNetworkStatus } from "../renderer/platform/networkStatus";

export default function useOfflineStatus() {
  const [isOffline, setIsOffline] = useState(!navigator.onLine);

  useEffect(() => {
    const updateOnlineStatus = () => setIsOffline(!navigator.onLine);

    // React to browser-level changes
    window.addEventListener("online", updateOnlineStatus);
    window.addEventListener("offline", updateOnlineStatus);

    const serviceWorkerMessage = (event) => {
        const { type } = event.data || {};
        if (type === "OFFLINE") setIsOffline(true);
        if (type === "ONLINE") setIsOffline(false);
    };
    if (!isElectron() && "serviceWorker" in navigator) {
      navigator.serviceWorker.addEventListener("message", serviceWorkerMessage);
    }

    const unsubscribeNetwork = subscribeNetworkStatus((online) => setIsOffline(!online));
    const refreshNativeStatus = () => void getNativeNetworkStatus().then((online) => setIsOffline(!online));
    refreshNativeStatus();
    const poll = isElectron() ? window.setInterval(refreshNativeStatus, 30_000) : undefined;

    return () => {
      window.removeEventListener("online", updateOnlineStatus);
      window.removeEventListener("offline", updateOnlineStatus);
      unsubscribeNetwork();
      if (poll) window.clearInterval(poll);
      if (!isElectron() && "serviceWorker" in navigator) {
        navigator.serviceWorker.removeEventListener("message", serviceWorkerMessage);
      }
    };
  }, []);

  return isOffline;
}
